import getPlans from './getPlans'
import getCustomerPlans from './getCustomerPlans'

/**
 * Resolves the initial checkout amount for a station by checking its plans.
 * Prioritizes the hourly plan ('four_hours') and falls back to 'daily' plan.
 * Applies the price variation factor if present.
 *
 * @param {number|string} pointId
 * @returns {Promise<number>}
 */
export default async function getCheckoutAmount(pointId) {
  try {
    const token = localStorage?.getItem('token') || null
    let plans = null
    if (token) {
      plans = await getCustomerPlans(pointId)
    } else {
      plans = await getPlans(pointId)
    }

    if (plans) {
      let selectedPlan = null
      if (plans.price && Array.isArray(plans.price)) {
        selectedPlan =
          plans.price.find(p => p.internal_ref === 'four_hours') || plans.price.find(p => p.internal_ref === 'daily')

        if (selectedPlan && selectedPlan.price_variation) {
          const variationFactor = 1 + selectedPlan.price_variation / 100
          const totalCentavos = Math.round(
            (parseInt(selectedPlan.amount.reais || 0) * 100 + parseInt(selectedPlan.amount.centavos || 0)) *
              variationFactor
          )
          return totalCentavos / 100
        } else if (selectedPlan?.amount?.reais !== undefined) {
          return parseInt(selectedPlan.amount.reais) + parseInt(selectedPlan.amount.centavos || 0) / 100
        }
      }
    }
  } catch (error) {
    console.warn('[getCheckoutAmount] Could not fetch plans or calculate amount:', error)
  }
  return 0
}
